// @flow
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { withHelmet } from 'infrastructure/seo/Helmet';
import type { BlocContent } from 'types/NewsletterBloc';
import type { Status } from 'types/Status';
import type { CompetitionType } from 'types/Competitions';

import { STATUS_LOADING } from 'constants/statusConstants';
import Loading from 'components/fragments/Loading';
import Breadcrumb from 'components/fragments/Breadcrumb';
import Sidebar from 'components/sidebar/Sidebar';
import ResultatListItem from 'components/competitions/ResultatListItem';
import NextRencontresCard from './NextRencontresCard';

export type StateProps = {
  title: string,
  featured_media: {
    src: string,
    legend: string
  },
  sidebar_content: Array<BlocContent>,
  status: Status,
  competition: CompetitionType,
};

export type DispatchProps = {
  fetchPageList: (slug: string) => void,
  fetchCompetitionsBySlug: (slug: string) => void,
};

type Props = {
  match: any,
  history: any,
  location: any,
} & DispatchProps &
  StateProps;

type State = {
  currentCompetitions: Array<CompetitionType>,
  endedCompetitions: Array<CompetitionType>,
}

class CompetitionDetail extends Component<Props, State> {
  state: State = {
    currentCompetitions: [],
    endedCompetitions: [],
  }

  componentDidMount() {
    const {
      fetchCompetitionsBySlug,
      fetchPageList,
      match: {
        params : { slug, competitionSlug }
      },
    } = this.props;
    fetchPageList(slug);
    fetchCompetitionsBySlug(competitionSlug);
  }

  renderResultatsSection = () => {
    const { competition : { dernieres_rencontres }, title } = this.props;
    return <ResultatListItem rencontres={dernieres_rencontres} equipeNom={title} title={'Résultats'}/>;
  }

  renderNextRencontresSection = () => {
    const {
      competition : { title: competitionTitle, prochaines_rencontres },
      title
    } = this.props;
    return (
      <NextRencontresCard
        rencontres={prochaines_rencontres}
        equipeNom={title}
        competitionTitle={competitionTitle}
        />
    );
  }

  render() {
    const {
      competition : { title: competitionTitle, prochaines_rencontres, dernieres_rencontres },
      title,
      status,
      featured_media,
      sidebar_content,
    } = this.props;
    const { typeRugby, slug } = this.props.match.params;
    if (status === STATUS_LOADING) {
      return <Loading />;
    }
    return (
      <Fragment>
        <section className="banner">
          <div className="banner__thumbnail img-blue-dark" style={{ backgroundImage: `url(${featured_media.src})` }} />
          <div className="container">
            <Breadcrumb
              elements={[
                { name: 'accueil', to: '/' },
                { name: 'Équipes de France', to: '/equipe-de-france' },
                { name: typeRugby.replace(/-/g, ' '), to: '/equipe-de-france/' + typeRugby },
                { name: title, to: '/equipe-de-france/' + typeRugby + '/' + slug },
                { name: 'Compétitions', to: `/equipe-de-france/${typeRugby}/${slug}/competitions`},
                `${competitionTitle}`
              ]}
              isDark />
            <h1 className="ft-h2">{competitionTitle}</h1>
          </div>
        </section>
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <section>
                <div className="row">
                  <div className="col">
                    <div className="header-filter__sep mb-6"/>
                  </div>
                </div>
                <div className="row">
                  <div className="col col-lg-8on9">
                    <div className="block-competition mb-md-4 mb-lg-0">
                      {dernieres_rencontres && dernieres_rencontres.length > 0 && this.renderResultatsSection()}
                      {prochaines_rencontres && prochaines_rencontres.length > 0 && this.renderNextRencontresSection()}
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <Sidebar sidebarContent={sidebar_content} />
          </div>
        </div>
      </Fragment>
    );
  }
}


export default withHelmet(withRouter(CompetitionDetail))((Helmet, pageProps) => {
  const { competition : { meta_title } } = pageProps;
  const ogimage = pageProps.featured_media ? pageProps.featured_media.src : false;
  const ogimagetitle = pageProps.featured_media ? pageProps.featured_media.title : false;

  return (
    <Helmet>
      <title>{meta_title}</title>
      <meta name={'description'} content={pageProps.meta_description} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={meta_title} />
      <meta property={'og:description'} content={pageProps.meta_description} />
      {ogimage && <meta property={'og:image'} content={ogimage} />}
      {ogimage && <meta property={'og:image:url'} content={ogimage} />}
      {(ogimage && ogimagetitle) && <meta property={'og:image:title'} content={ogimagetitle} />}
    </Helmet>
  );
});
